import React, {useEffect, useState} from "react";
import {getProductPrices} from "../../services/ProductRepository";
import {ProductItem} from "./ProductItem";

export function Prices() {

    const [products, setProducts] = useState([]);

    useEffect(() => {
        getProductPrices().then(result => {
            setProducts(result)
            console.log("PRICES: ", result)
        }).catch(e => console.log(e))
    }, []);


    return (
        <div className={"bg-light"} style={{fontFamily: "Poppins"}}>
            <div className={"container p-5 "}>

                <h2 className={"text-center mb-4"}>Priser</h2>
                <div className={"row"}>
                    {
                        products.map(item => (
                            <ProductItem name={item.name} features={item.features} price={item.price} display={true}/>
                        ))
                    }
                </div>

                <p className={"px-2 text-muted text-center"}>
                    Elementer markert med * er produkter som kun er tilgjengelig i noen fag. For eksempel vil labhefte kun
                    være inkludert i Kjemi og Naturfag.
                </p>


                <div className={"mt-5"}>
                    <h4>Notater</h4>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum et lacus et sem pellentesque
                        sollicitudin non at sem. Phasellus venenatis vulputate mi non luctus. Curabitur bibendum
                        interdum lectus quis finibus. Vestibulum commodo odio eu risus posuere, in tempor ipsum
                        porttitor. Nulla consequat volutpat elit non vestibulum. Vestibulum eget est eu dolor luctus
                        pharetra. In eu lectus nibh. Sed laoreet lectus nec justo accumsan, sit amet luctus nibh congue.
                        Praesent dignissim ligula eu mi volutpat eleifend. Integer efficitur id neque cursus tincidunt.
                        Sed vel ex sit amet enim scelerisque cursus. In finibus dapibus dui, nec gravida metus. Fusce in
                        erat egestas, vestibulum erat id, interdum elit. Nam finibus sem et ante vulputate, sit amet
                        consectetur lectus congue. Nulla ac tellus dictum, pulvinar sapien ut, hendrerit nisi</p>
                </div>

                <div className={"mt-5"}>
                    <h4>Oppgaver</h4>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum et lacus et sem pellentesque
                        sollicitudin non at sem. Phasellus venenatis vulputate mi non luctus. Curabitur bibendum
                        interdum lectus quis finibus. Vestibulum commodo odio eu risus posuere, in tempor ipsum
                        porttitor. Nulla consequat volutpat elit non vestibulum. Vestibulum eget est eu dolor luctus
                        pharetra. In eu lectus nibh. Sed laoreet lectus nec justo accumsan, sit amet luctus nibh congue.
                        Praesent dignissim ligula eu mi volutpat eleifend. Integer efficitur id neque cursus tincidunt.
                        Sed vel ex sit amet enim scelerisque cursus. In finibus dapibus dui, nec gravida metus. Fusce in
                        erat egestas, vestibulum erat id, interdum elit. Nam finibus sem et ante vulputate, sit amet
                        consectetur lectus congue. Nulla ac tellus dictum, pulvinar sapien ut, hendrerit nisi</p>
                </div>


                <div className={"mt-5"}>
                    <h4>KI</h4>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum et lacus et sem pellentesque
                        sollicitudin non at sem. Phasellus venenatis vulputate mi non luctus. Curabitur bibendum
                        interdum lectus quis finibus. Vestibulum commodo odio eu risus posuere, in tempor ipsum
                        porttitor. Nulla consequat volutpat elit non vestibulum. Vestibulum eget est eu dolor luctus
                        pharetra. In eu lectus nibh. Sed laoreet lectus nec justo accumsan, sit amet luctus nibh congue.
                        Praesent dignissim ligula eu mi volutpat eleifend. Integer efficitur id neque cursus tincidunt.
                        Sed vel ex sit amet enim scelerisque cursus. In finibus dapibus dui, nec gravida metus. Fusce in
                        erat egestas, vestibulum erat id, interdum elit. Nam finibus sem et ante vulputate, sit amet
                        consectetur lectus congue. Nulla ac tellus dictum, pulvinar sapien ut, hendrerit nisi</p>
                </div>

                <div className={"mt-5"}>
                    <h4>Evalueringsplattform</h4>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum et lacus et sem pellentesque
                        sollicitudin non at sem. Phasellus venenatis vulputate mi non luctus. Curabitur bibendum
                        interdum lectus quis finibus. Vestibulum commodo odio eu risus posuere, in tempor ipsum
                        porttitor. Nulla consequat volutpat elit non vestibulum. Vestibulum eget est eu dolor luctus
                        pharetra. In eu lectus nibh. Sed laoreet lectus nec justo accumsan, sit amet luctus nibh congue.
                        Praesent dignissim ligula eu mi volutpat eleifend. Integer efficitur id neque cursus tincidunt.
                        Sed vel ex sit amet enim scelerisque cursus. In finibus dapibus dui, nec gravida metus. Fusce in
                        erat egestas, vestibulum erat id, interdum elit. Nam finibus sem et ante vulputate, sit amet
                        consectetur lectus congue. Nulla ac tellus dictum, pulvinar sapien ut, hendrerit nisi</p>
                </div>

                <div className={"mt-5"}>
                    <h4>Quiz</h4>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum et lacus et sem pellentesque
                        sollicitudin non at sem. Phasellus venenatis vulputate mi non luctus. Curabitur bibendum
                        interdum lectus quis finibus. Vestibulum commodo odio eu risus posuere, in tempor ipsum
                        porttitor. Nulla consequat volutpat elit non vestibulum. Vestibulum eget est eu dolor luctus
                        pharetra. In eu lectus nibh. Sed laoreet lectus nec justo accumsan, sit amet luctus nibh congue.
                        Praesent dignissim ligula eu mi volutpat eleifend. Integer efficitur id neque cursus tincidunt.
                        Sed vel ex sit amet enim scelerisque cursus. In finibus dapibus dui, nec gravida metus. Fusce in
                        erat egestas, vestibulum erat id, interdum elit. Nam finibus sem et ante vulputate, sit amet
                        consectetur lectus congue. Nulla ac tellus dictum, pulvinar sapien ut, hendrerit nisi</p>
                </div>

                <div className={"mt-5"}>
                    <h4>Flashcards</h4>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum et lacus et sem pellentesque
                        sollicitudin non at sem. Phasellus venenatis vulputate mi non luctus. Curabitur bibendum
                        interdum lectus quis finibus. Vestibulum commodo odio eu risus posuere, in tempor ipsum
                        porttitor. Nulla consequat volutpat elit non vestibulum. Vestibulum eget est eu dolor luctus
                        pharetra. In eu lectus nibh. Sed laoreet lectus nec justo accumsan, sit amet luctus nibh congue.
                        Praesent dignissim ligula eu mi volutpat eleifend. Integer efficitur id neque cursus tincidunt.
                        Sed vel ex sit amet enim scelerisque cursus. In finibus dapibus dui, nec gravida metus. Fusce in
                        erat egestas, vestibulum erat id, interdum elit. Nam finibus sem et ante vulputate, sit amet
                        consectetur lectus congue. Nulla ac tellus dictum, pulvinar sapien ut, hendrerit nisi</p>
                </div>

                <div className={"mt-5"}>
                    <h4>Eksamensoppgaver</h4>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum et lacus et sem pellentesque
                        sollicitudin non at sem. Phasellus venenatis vulputate mi non luctus. Curabitur bibendum
                        interdum lectus quis finibus. Vestibulum commodo odio eu risus posuere, in tempor ipsum
                        porttitor. Nulla consequat volutpat elit non vestibulum. Vestibulum eget est eu dolor luctus
                        pharetra. In eu lectus nibh. Sed laoreet lectus nec justo accumsan, sit amet luctus nibh congue.
                        Praesent dignissim ligula eu mi volutpat eleifend. Integer efficitur id neque cursus tincidunt.
                        Sed vel ex sit amet enim scelerisque cursus. In finibus dapibus dui, nec gravida metus. Fusce in
                        erat egestas, vestibulum erat id, interdum elit. Nam finibus sem et ante vulputate, sit amet
                        consectetur lectus congue. Nulla ac tellus dictum, pulvinar sapien ut, hendrerit nisi</p>
                </div>
            </div>
        </div>

    );

}